export default "__VITE_ASSET__BOTTYIKo__"